class RecipesGallery extends HTMLElement {
  constructor() {
    super();
    this.checkboxes = [];
    this.recipeCards = [];
    this.emptyState = null;
    this.resetBtn = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.checkboxes = Array.from(this.querySelectorAll('input[data-category-filter]'));
    this.recipeCards = Array.from(this.querySelectorAll('[data-category-item]'));
    this.emptyState = this.querySelector('[data-recipes-empty]');
    this.resetBtn = this.querySelector('[data-recipes-reset]');

    if (!this.checkboxes.length || !this.recipeCards.length) return;

    this.bindEvents();
    this.checkInitialCategory();
  }

  bindEvents() {
    this.checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        this.filterRecipes();
      });
    });

    if (this.resetBtn) {
      this.resetBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.checkboxes.forEach(cb => { cb.checked = false; });
        this.filterRecipes();
      });
    }

    window.addEventListener('popstate', () => {
      this.checkInitialCategory();
    });

    // Theme Editor (Design Mode) integration
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', (e) => {
        const blockId = e.detail?.blockId;
        const blockEl = document.getElementById(`shopify-block-${blockId}`) || this.querySelector(`[data-shopify-editor-block*="${blockId}"]`);
        const cb = blockEl ? blockEl.querySelector('input[data-category-filter]') : null;
        if (cb) {
          this.checkboxes.forEach(c => { c.checked = false; });
          cb.checked = true;
          this.filterRecipes(false);
        }
      });
    }
  }

  checkInitialCategory() {
    const params = new URLSearchParams(window.location.search);
    const categoryParam = params.get('category');
    const hash = window.location.hash ? window.location.hash.replace('#', '') : null;
    const targetSlugs = (categoryParam || hash || '')
      .toLowerCase()
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);

    if (targetSlugs.length > 0) {
      this.checkboxes.forEach(cb => {
        const slug = (cb.getAttribute('data-category-filter') || '').toLowerCase().trim();
        cb.checked = targetSlugs.includes(slug);
      });
    } else {
      this.checkboxes.forEach(cb => {
        cb.checked = false;
      });
    }

    this.filterRecipes(false);
  }

  filterRecipes(updateUrl = true) {
    const checkedCategories = this.checkboxes
      .filter(cb => cb.checked)
      .map(cb => cb.getAttribute('data-category-filter').toLowerCase().trim());

    let visibleCount = 0;

    this.recipeCards.forEach(card => {
      const cardCategories = (card.getAttribute('data-category') || '')
        .toLowerCase()
        .split(',')
        .map(c => c.trim());

      // If no checkboxes checked, show all. Otherwise show if card has any checked category
      const shouldShow = checkedCategories.length === 0 || checkedCategories.some(cat => cardCategories.includes(cat));

      if (shouldShow) {
        card.classList.remove('is-hidden');
        card.style.display = '';
        visibleCount++;
      } else {
        card.classList.add('is-hidden');
        card.style.display = 'none';
      }
    });

    // Handle Empty State
    if (this.emptyState) {
      if (visibleCount === 0) {
        this.emptyState.style.display = 'block';
        this.emptyState.removeAttribute('hidden');
      } else {
        this.emptyState.style.display = 'none';
        this.emptyState.setAttribute('hidden', '');
      }
    }

    // Update URL without page reload
    if (updateUrl && window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      if (checkedCategories.length === 0) {
        url.searchParams.delete('category');
        if (url.hash) url.hash = '';
      } else {
        url.searchParams.set('category', checkedCategories.join(','));
      }
      window.history.replaceState({}, '', url.toString());
    }
  }
}

if (!customElements.get('recipes-gallery')) {
  customElements.define('recipes-gallery', RecipesGallery);
}
